// Reads UTM + variant params from the current URL, stashes them in
// sessionStorage on first visit so they persist across navigation, and
// returns a shape ready to send to /api/orders as `utm`.

const KEY = "bv_utm";

const UTM_KEYS = ["source", "medium", "campaign", "content", "term"];

export function captureUTM() {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const fromUrl = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(`utm_${k}`);
    if (v) fromUrl[k] = v;
  });
  const variant = params.get("v");
  if (variant) fromUrl.variant = variant;

  if (Object.keys(fromUrl).length > 0) {
    sessionStorage.setItem(KEY, JSON.stringify(fromUrl));
    return fromUrl;
  }
  try {
    const stored = sessionStorage.getItem(KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function getUTM() {
  if (typeof window === "undefined") return null;
  try {
    const stored = sessionStorage.getItem(KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}
